"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var setDefaultStoredValue = function setDefaultStoredValueHelper(fieldData, displayName) {
  switch (displayName) {
    case 'RangeInputControl':
      return parseInt(fieldData.value, 10) || parseInt(fieldData.control.options["default"], 10);

    default:
      return fieldData.value || '';
  }
};

var _default = setDefaultStoredValue;
exports["default"] = _default;